
import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../index2.css'
import styles from './Dropdown.module.css'


export default function Dropdown(props) {

    //useRef to toggle the scroll effect
    const dropdownRef = useRef();

    //useRef to toggle betwween shown and hiding the menu
    const dropdownMenuRef = useRef();

    //When a supmenu is clicked, the dropdown should disapere
    const handleClick = () => {
        props.setDropDown(false);
        if(props.mobileMenu) {
            props.handleClickMobilMenu();
        }
    };

     //   scroll effect på dropdown
     useEffect(() => {
        const handleScroll = () => {
            
              if (window.scrollY > 500) {
                dropdownRef.current.classList.add(styles.navDropdownScrolled);
              } else {
                dropdownRef.current.classList.remove(styles.navDropdownScrolled);
              }
          };
    
        document.addEventListener("scroll", handleScroll);
    
        return () => {
          document.removeEventListener("scroll", handleScroll);
        };
      }, []);

      useEffect(() => {
        if(props.dropdown){
            dropdownMenuRef.current.classList.add(styles.navDropdownMenuShow);
        } else {
            dropdownMenuRef.current.classList.remove(styles.navDropdownMenuShow);
        }
      }, [props.dropdown]);

    return (
        <div  className={styles.navDropdownMenu} ref={dropdownMenuRef}>
            <ul className={styles.navDropdown} ref={dropdownRef}>  
                { props.dropdown && props.items.map(item=> {
                    return(
                        <li  key={item.id} className={styles.navDropdownMenuItems} onClick={ handleClick}>
                            <Link to={item.path} className={styles[item.cName]}>{item.title}</Link>
                        </li>
                    );
                })}
                
            </ul>
        </div>
    );
}